import { TransmissionSystemOperatorResource } from 'app/_resources/transmission-system-operator.resource';
import { Growl } from 'angular/custom/services/growl.service';
import { AuthService } from 'app/_services/auth.service';
import { ErrorHandler } from 'app/_services/error-handler.factory';
import { ConfirmModal } from 'app/_services/confirm-modal.factory';
import * as angular from 'angular';

class MaintenanceMessagesComponentCtrl implements ng.IController {
    private errorMessage: string;
    private maintenanceMessageCreationCollapsed = true;
    private loading: boolean;
    private loggedInUser: LoginResult;
    private order = 'publicationDate';
    private orderReverse = false;
    private maintenanceMessages: MaintenanceMessageDto[];
    private idOfMaintenanceMessageCurrentlyBeingEdited: number;
    private idOfMaintenanceMessageBeingDeleted: number;

    constructor(
        private TransmissionSystemOperator: TransmissionSystemOperatorResource,
        private growl: Growl,
        private authService: AuthService,
        private errorHandler: ErrorHandler,
        private confirmModal: ConfirmModal
    ) {}

    $onInit(): void {
        this.loading = true;

        this.authService.userLoginPromise.promise.then(
            (loginResult: LoginResult) => {
                this.loggedInUser = loginResult;
                this.loadMaintenanceMessages();
            }
        );
    }

    private loadMaintenanceMessages(): ng.IPromise<MaintenanceMessageDto[]> {
        return this.TransmissionSystemOperator.queryMaintenanceMessages(
            { id: this.loggedInUser.referenceId },
            (res: MaintenanceMessageDto[]) => {
                this.maintenanceMessages = res;
                this.errorMessage = undefined;
            },
            (err: ng.IHttpPromiseCallbackArg<RestError>) => {
                this.errorMessage =
                    err.data && err.data.message
                        ? err.data.message
                        : 'An unknown error occurred. Please, check back later.';
            }
        ).$promise.finally(() => (this.loading = false));
    }

    private deleteMaintenanceMessage(
        maintenanceMessage: MaintenanceMessageDto
    ) {
        this.idOfMaintenanceMessageBeingDeleted = maintenanceMessage.id;

        this.confirmModal(
            'Do you really want to delete the maintenance message?'
        )
            .result.then(() => {
                this.TransmissionSystemOperator.deleteMaintenanceMessage(
                    {
                        id: this.loggedInUser.referenceId,
                        maintenanceMessageId: maintenanceMessage.id
                    },
                    () => {
                        this.growl.show('Successfully deleted.', 'success');
                        this.maintenanceMessages.splice(
                            this.maintenanceMessages.indexOf(
                                maintenanceMessage
                            ),
                            1
                        );

                        if (
                            this.idOfMaintenanceMessageCurrentlyBeingEdited ==
                            maintenanceMessage.id
                        ) {
                            this.idOfMaintenanceMessageCurrentlyBeingEdited =
                                null;
                        }
                    },
                    this.errorHandler
                ).$promise.finally(
                    () => (this.idOfMaintenanceMessageBeingDeleted = null)
                );
            })
            .finally(() => (this.idOfMaintenanceMessageBeingDeleted = null));
    }

    private onMaintenanceMessageCreation(
        savedMaintenanceMessage: MaintenanceMessageDto
    ): void {
        const indexOfSavedMaintenanceMessage: number =
            this.maintenanceMessages.findIndex(
                (mm: MaintenanceMessageDto) =>
                    mm.id === savedMaintenanceMessage.id
            );

        if (indexOfSavedMaintenanceMessage === -1) {
            this.maintenanceMessageCreationCollapsed = true;
            this.maintenanceMessages.push(savedMaintenanceMessage);
        } else {
            this.maintenanceMessages[indexOfSavedMaintenanceMessage] =
                savedMaintenanceMessage;
            this.idOfMaintenanceMessageCurrentlyBeingEdited = null;
        }
    }
}

angular.module('app').component('pkpMaintenanceMessages', {
    controller: MaintenanceMessagesComponentCtrl,
    template: require('app/maintenance-messages/maintenance-messages.component.html'),
    bindings: {}
});
